<template>
  <el-dialog
    v-model="dialogVisible"
    title="重置密码"
    width="520px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="handleClose"
  >
    <el-form ref="ruleFormRef" :model="form" label-position="top">
      <el-form-item label="商户名">
        <div class="user-name">{{ props.record?.userName || '-' }}</div>
      </el-form-item>
      <el-form-item
        label="新密码"
        prop="newPsw"
        :rules="[
          { required: true, message: '请输入新密码', trigger: ['blur', 'change'] },
          { validator: validatePassword, trigger: ['blur', 'change'] },
        ]"
      >
        <el-input
          v-model="form.newPsw"
          type="password"
          show-password
          show-word-limit
          :maxlength="12"
          placeholder="请输入新密码"
        >
          <template #append>
            <el-button @click="generatePassword">随机生成</el-button>
          </template>
        </el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="handleClose">取消</el-button>
      <el-button :loading="submitting" type="primary" @click="handleSubmit">提交</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { inject, reactive, ref, toRefs } from "vue"
import { dialogProps } from "@/mixins/dialog"
import { md5 } from "js-md5"
import { resetPwd } from "@/api/systemUser"

const props = defineProps({
  ...dialogProps,
})

const $tm_message_box = inject("$tm_message_box")
const ruleFormRef = ref(null)
const state = reactive({
  dialogVisible: true,
  submitting: false,
})
const form = reactive({
  newPsw: "",
})

const { dialogVisible, submitting } = toRefs(state)
const PASSWORD_CHARSET = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789!@#$%^&*()_+-=[]{}|;:,.?"

const validatePassword = (rule, value, callback) => {
  if (!value) {
    callback(new Error("请输入新密码"))
    return
  }
  if (value.length > 12) {
    callback(new Error("密码最长12位"))
    return
  }
  if (!/[A-Z]/.test(value) || !/[a-z]/.test(value) || !/\d/.test(value) || !/[!@#$%^&*()_+\-=[\]{}|;:,.?]/.test(value)) {
    callback(new Error("密码需包含大写字母、小写字母、数字和常见符号"))
    return
  }
  callback()
}

const buildRandomPassword = () => {
  const required = [
    "ABCDEFGHJKLMNPQRSTUVWXYZ",
    "abcdefghijkmnopqrstuvwxyz",
    "23456789",
    "!@#$%^&*()_+-=[]{}|;:,.?"
  ]
  const chars = required.map(group => group[Math.floor(Math.random() * group.length)])
  while (chars.length < 12) {
    chars.push(PASSWORD_CHARSET[Math.floor(Math.random() * PASSWORD_CHARSET.length)])
  }
  return chars.sort(() => Math.random() - 0.5).join("")
}

const generatePassword = () => {
  form.newPsw = buildRandomPassword()
  ruleFormRef.value?.validateField("newPsw", () => {})
}

const handleSubmit = () => {
  ruleFormRef.value?.validate(async valid => {
    if (!valid) return
    state.submitting = true
    try {
      await resetPwd({
        id: props.record?.id,
        newPsw: md5(form.newPsw),
      })
      $tm_message_box.toast("密码重置成功", { type: "success" })
      props.ok()
    } finally {
      state.submitting = false
    }
  })
}

const handleClose = () => {
  props.close()
}
</script>

<style lang="less" scoped>
.user-name {
  min-height: 32px;
  line-height: 32px;
  color: #303133;
}
</style>
